<template>
    <div class="card card-body">
        <div class="d-block d-md-flex justify-content-md-between">
            <div class="d-flex">
                <div>
                    <div class="pr-3 vehicle-image">
                        <image-swiper
                            :has-thumbs="false"
                            :images="imageUrls"/>
                    </div>
                </div>
                <div>
                    <p class="detail bold">
                        {{ vehicle.formatted_shortened_name }}
                        <span v-if="vehicle.vehicle_trim">
                            {{ ' ' + vehicle.vehicle_trim.name }}
                        </span>
                    </p>
                    <p class="detail">Condition: {{ condition }}</p>
                    <p class="detail">Color: {{ color }}</p>
                    <p class="detail">Status:
                        <span>
                            <i :class="[vehicleStatusClass]"
                               class="mdi mdi-checkbox-blank-circle"/>
                            {{ vehicleStatusLabel }}
                        </span>
                    </p>
                    <div v-if="isWholesale" class="mb-2">
                        <span class="badge badge-secondary">Wholesale</span>
                    </div>
                </div>
            </div>
            <div class="text-left text-md-right">
                <div class="d-flex justify-content-start justify-content-md-end">
                    <p class="m-0 pr-2 listings-only-title">Visible</p>
                    <input
                        id="visible-switch"
                        :checked="!isHidden"
                        switch="none"
                        type="checkbox"
                    />
                    <label
                        id="visible-switch"
                        data-off-label="No"
                        data-on-label="Yes"
                        @click="onChangeVisibility"
                    />
                </div>
                <p class="bold">{{ vehicle.price | currency }}</p>
                <p class="bold">{{ vehicle.mileage | local_number }} Mileage</p>
                <p v-if="vehicle.total_days_on_floor !== null" class="bold">
                    {{ vehicle.total_days_on_floor + ' day' + (vehicle.total_days_on_floor > 1 ? 's' : '') }}
                </p>
                <div>
                    <!-- <div class="d-inline-block">
                        <div class="form-group row mb-2 ml-n3">
                            <label class="col-sm-5 col-lg-4 col-form-label">Assignee:</label>
                            <div class="col-sm-7 col-lg-8">
                                <select :value="vehicle.assignee_id"
                                        class="form-control"
                                        title="assignee"
                                        @change="onAssigneeChange">
                                    <option :value="null" disabled>Select Assignee</option>
                                    <option v-for="user in users.data"
                                            :key="user.id"
                                            :value="user.id">
                                        {{ user.name }} {{ user.id === authUser.id ? '(Assign to me)' : '' }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div> -->
                    <div class="d-inline-block">
                        <button
                            class="btn-action btn btn-sm btn-secondary waves-effect waves-light"
                            type="button"
                            @click="editVehicle"
                        >
                            <i class="mdi mdi-pencil"/>
                            Edit
                        </button>
                        <button
                            class="btn-action btn btn-sm btn-secondary waves-effect waves-light"
                            type="button"
                            @click="viewVehicle"
                        >
                            <i class="mdi mdi-details"/>
                            Details
                        </button>
                        <button
                            class="btn-action btn btn-sm btn-primary waves-effect waves-light"
                            type="button"
                            @click="share"
                        >
                            <i class="mdi mdi-send"/>
                            Send to
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <ShareModal
            ref="shareModal"
            :vehicle="vehicle"
            @success="onSuccessShare"
        />
    </div>
</template>

<script>
import ImageSwiper from "@/components/custom/ImageSwiper";

import {createNamespacedHelpers, mapState} from 'vuex'
import {debounce, map} from 'lodash'
import vehicleMixin from '@/mixins/vehicle'
import {CHANGE_VEHICLE_VISIBILITY, SAVE_INVENTORY_VEHICLE} from "@/store/modules/vehicle/actions";
import Routes from "@/constants/routes";
import ShareModal from "@/components/main/vehicle/ShareModal";

const {mapActions} = createNamespacedHelpers('vehicle')
export default {
    mixins: [
        vehicleMixin
    ],
    props: {
        vehicle: {
            type: Object,
            default: null,
        }
    },
    components: {
        ImageSwiper,
        ShareModal
    },
    computed: {
        ...mapState('userModule', ['users']),
        imageUrls() {
            if (!this.vehicle) {
                return [];
            }
            return map(this.vehicle.top_images, image => image.url)
        },
        authUser() {
            return this.$store.state.user
        }
    },
    methods: {
        ...mapActions([CHANGE_VEHICLE_VISIBILITY, SAVE_INVENTORY_VEHICLE]),
        onChangeVisibility() {
            this[CHANGE_VEHICLE_VISIBILITY]({vehicle: this.vehicle, hide: !this.vehicle.hid_at});
        },
        viewVehicle() {
            this.$router.push({
                name: Routes.view_vehicle,
                params: {
                    id: this.vehicle.id,
                },
                query: {
                    back: this.$route.fullPath
                }
            })
        },
        editVehicle() {
            this.$router.push({
                name: Routes.edit_vehicle,
                params: {
                    id: this.vehicle.id,
                },
                query: {
                    back: this.$route.fullPath
                }
            });
        },
        share() {
            this.$refs.shareModal.show();
        },
        onSuccessShare(share) {
            this.$refs.shareModal.hide();
        },
        onAssigneeChange: debounce(function (event) {
            this[SAVE_INVENTORY_VEHICLE]({vehicle: this.vehicle, form: {assignee_id: event.target.value}})
        }, 600)
    }
}
</script>

<style scoped>
.vehicle-image {
    height: 190px;
    width: 305px;
    object-fit: cover;
    overflow: hidden;
}

.btn-action {
    height: 32px;
}

@media (max-width: 380px){
    .vehicle-image {
        width: 160px;
        height: auto;
    }
}

@media (min-width: 381px) and (max-width: 480px) {
    .vehicle-image {
        width: 200px;
        height: auto;
    }
}

@media (min-width: 481px) and (max-width: 820px) {
    .vehicle-image {
        width: 250px;
        height: auto;
    }
}
</style>
